import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Filtering from "../RuleCatalogue/Filtering";
import KpiCard from "../RuleCatalogue/KpiCard";
import Tables from "../RuleCatalogue/Tables";
import Skeleton from "@mui/material/Skeleton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";


const RuleCatalogue = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const [page, setPage] = useState(1); // pagination from landing page
  const [ruleData, setRuleData] = useState(
    {
      "rules": {
          "totalRules": {
              "id": 1,
              "score": 45
          },
          "activeRules": {
              "id": 2,
              "score": 45
          },
          "hardChecks": {
              "id": 3,
              "score": 31
          },
          "businessRules": {
              "id": 4,
              "score": 31
          }
      },
      "tableData": [
          {
              "ruleId": "46F38C8C-ACF0-4043-9EE1-75AE03A4FB0C",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_gathered_timestamp_is_not_in_future",
              "description": "Checks whether the timestamp is not in the future.",
              "dqDimension": "freshness",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "1%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "CDF1F6E0-0103-441E-AE46-C0A5CD465C13",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_edh_inserted_timestamp_is_not_in_future",
              "description": "Checks whether the timestamp is not in the future.",
              "dqDimension": "freshness",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "1%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "86CCDECC-E7ED-456C-8BAB-6178C3635C1C",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_country_is_in_list",
              "description": "Checks whether the values are in the allowed list.",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "3%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "122FC220-F6DF-41EF-A28E-D329BCDD364C",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_avg_rating_is_equal_to",
              "description": "Checks whether the values in the input column are equal to the provided value.",
              "dqDimension": "accuracy",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": [
                  "Negative Review"
              ],
              "threshold": "1%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "B593A719-0814-47C4-975F-F9EC43A48114",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_edh_inserted_timestamp_is_valid_timestamp",
              "description": "Checks whether the values have valid timestamp format.",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "2%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "A75074B1-CD81-43A0-937B-002E5C1A13D6",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_edh_updated_timestamp_is_valid_timestamp",
              "description": "Checks whether the values have valid timestamp format.",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "5%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "F276786A-AAD4-43E9-9861-305F4B207DE7",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_comment_count_is_not_less_than",
              "description": "filter feedback above 2000 tractions",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "4%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "BF201AF4-30DF-4653-BCCB-DD02EC61F604",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_feedback_recommendation_is_not_less_than",
              "description": "Checks whether the values are not less than the limit.",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "2%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "D09A6683-F875-44D1-9473-85BD66DA8D69",
              "ruleName": "snacking_snackingdataquality|global_x_seg_feedback_sample_12345_price_is_not_less_than",
              "description": "Checks whether the values are not less than the limit.",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "5%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          },
          {
              "ruleId": "EF8BC525-A94B-4FA9-B803-023E9D960A70",
              "ruleName": "avg_rating _check4and5",
              "description": "Rows w rating between 4 and 5",
              "dqDimension": "validity",
              "checkType": "CDE",
              "rulePhase": "N/A",
              "category": "Business",
              "keywords": "N/A",
              "threshold": "2%",
              "remediationAction": "N/A",
              "owner": "N/A",
              "status": "Active"
          }
      ],
      "filters": {
          "name": [
              "Region",
              "Market",
              "Retailer",
              "Category/Brand",
              "Product"
          ],
          "list": {
              "Region": [
                  "",
                  "Asia Pacific",
                  "Latin America",
                  "North America"
              ],
              "Market": [
                  "",
                  "India",
                  "Mexico"
              ],
              "Retailer": [
                  "",
                  "Albertsons-US",
                  "Amazon-US",
                  "Tesco"
              ],
              "Category/Brand": [
                  "",
                  "Chocolate",
                  "FoodServiceDirect",
                  "ISE Forest Garden"
              ],
              "Product": [
                  "",
                  "Haribo Confectionery Gold Bears Gummi Candy - 10 Ounce (Pack of 8)",
                  "Snickers",
                  "Swizzels Matlow Children's Bumper Bag (210g)"
              ]
          },
          "rulePhase": [
              "Post - Refresh",
              "Pre - Refresh"
          ]
      },
      "pagination": {
          "currentPage": 1,
          "pageSize": 10,
          "totalPages": 5,
          "totalRecords": 48
      }
  }
  );
  const BASE_URL = process.env.REACT_APP_API_URL;
  const initialLoaded = useRef(false);
  const [loading, setLoading] = useState(false);
  const [columnFilters, setColumnFilters] = useState({});



  // ✅ Get product name from localStorage
  const getProductName = () => {
    try {
      const name = localStorage.getItem("selectedProductName");
      if (name && name.trim()) {
        return name.trim().replace(/[^a-zA-Z0-9\s-_]/g, "").replace(/\s+/g, "_");
      }
    } catch (error) {
      console.warn("Error reading product name from localStorage:", error);
    }
    return "Product";
  };
const handleColumnFiltersChange = (filters) => {
  setColumnFilters(filters);
};
  // ✅ Generate timestamp
  const getTimestamp = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const h = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const s = String(now.getSeconds()).padStart(2, "0");
    return `${y}${m}${d}_${h}${min}${s}`;
  };

  // ✅ Export to Excel
  const exportToExcel = (data) => {
    if (!data || data.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rules");

    const filename = `${getProductName()}_${getTimestamp()}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, filename);
  };
  

  // ✅ Handle export button
  const handleExport = () => {
    if (!productId) return;

    const payload = {
      productId,
      filters: currentFilters,
      searchTerm,
      page: 1,
      pageSize: 10000, // Fetch all data
    };

    axios
      .post(`${BASE_URL}/rule-catalouge-results`, payload)
      .then((res) => {
        exportToExcel(res.data.tableData || []);
      })
      .catch((err) => console.error("Error exporting full data:", err));
  };

  // ✅ Data fetch
  // useEffect(() => {
  //   if (!productId) return;

  //   const payload = {
  //     productId,
  //     filters: currentFilters,
  //     searchTerm,
  //     page,
  //     pageSize: 10,
  //     ...columnFilters,
  //   };
  //    setLoading(true);

  //   axios
  //     .post(`${BASE_URL}/rule-catalouge-results`, payload)
  //     .then((res) => {
  //       const resData = res.data;
  //       setRuleData((prev) =>
  //         initialLoaded.current
  //           ? {
  //               ...prev,
  //               rules: resData.rules,
  //               tableData: resData.tableData,
  //               filters: resData.filters ?? prev?.filters,
  //               pagination: resData.pagination ?? prev?.pagination,
  //             }
  //           : resData
  //       );
  //       initialLoaded.current = true;
  //     })
  //     .catch((err) => console.error("Error fetching rule catalogue:", err))
  //     .finally(() => {
  //     setLoading(false); 
  //   });
  // }, [currentFilters, searchTerm, page, productId, BASE_URL,columnFilters]);
  
  useEffect(() => {
  setPage(1);
}, [searchTerm, currentFilters]);

const handlePageChange = (p) => {
  setLoading(true); 
  setPage(p);
};

  // ✅ Show loading skeleton while data loads
  if (!ruleData) {
    return (
    <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
      <div className="flex flex-col items-center space-y-3">
        <img src={preloader} alt="Loading..." width={200} />
        <span className="text-gray-700 text-[20px] text-center">
          Hang tight! The resources are loading...
        </span>
      </div>
    </div>
    );
  }

  // ✅ Final render
  return (
    <div className="rule-catalogue">
      <Filtering
        availableFilters={ruleData.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        showSearch={true}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
      />
      <KpiCard rules={ruleData.rules} />
      <Tables
        tableData={ruleData.tableData}
        pagination={ruleData.pagination}
        onPageChange={handlePageChange}
        onExport={handleExport}
         searchTerm={searchTerm}        
  onSearchChange={onSearchChange}
          loading={loading}     
          onColumnFiltersChange={handleColumnFiltersChange}           
      />
    </div>
  );
};

export default RuleCatalogue;
